<template>
  <div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="280px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="Title"
        prop="title"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-input
          type="textarea"
          :rows="2"
          placeholder=""
          v-model="ruleForm.title"
        >
        </el-input>
      </el-form-item>
      <el-form-item
        label="Reg. No"
        prop="registrationNo"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-input v-model="ruleForm.registrationNo"></el-input>
      </el-form-item>
      <el-form-item
        label="Type"
        prop="type"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-select v-model="ruleForm.type" placeholder="">
          <el-option
            v-for="(item, index) in eventType"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Start Day"
        prop="startDate"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-form-item>
          <el-date-picker
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="Input Start day"
            v-model="ruleForm.startDate"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="End Day"
        prop="endDate"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-form-item>
          <el-date-picker
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="Input End day"
            v-model="ruleForm.endDate"
          ></el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item
        label="Expired"
        prop="isExpired"
        :rules="[{ required: true, message: '', trigger: 'blur' }]"
      >
        <el-radio-group v-model="ruleForm.isExpired">
          <el-radio :label="true">Yes</el-radio>
          <el-radio :label="false">No</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Academic Performance Level">
           <el-form-item label="" class="level-item" >
               <el-input v-model="ruleForm.level1" placeholder="Input Level 1"></el-input>
           </el-form-item>
           <el-form-item label="" class="level-item" >
               <el-input v-model="ruleForm.level2" placeholder="Input Level 2"></el-input>
           </el-form-item>
           <el-form-item label="" class="level-item" >
               <el-input v-model="ruleForm.level3" placeholder="Input Level 3"></el-input>
           </el-form-item>
      </el-form-item>
      <el-form-item label="Application Note" >
        <tinymceVue :key="key" v-model="ruleForm.applicationNode"></tinymceVue>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tinymceVue from "@/components/tinymceVue";
export default {
  components: { tinymceVue },
  props: {
    ruleForm: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      key: false
    }
  },
  mounted() {
     setTimeout(()=>{
          this.key = true
            },1000)
  },
  methods:{
  }
};
</script>

<style lang="scss" scoped>
::v-deep{
  .level-item{
    margin-bottom: 20px;
  }
}
</style>